import React, { memo, useState, useEffect } from 'react';
import Grid from './grid';
import SubsidiariesMap from './subsidiariesMap';
// import '@style/modules/analysis/analysisRight.scss';
import '../../../../styles/modules/analysis/analysisRight.scss';
import { ExpandButton, SwitchBtn, Loading } from '@components';
import { useSelector, useDispatch, connect } from 'react-redux';
import { Modal } from 'antd';
import { API } from '@service';
import {
  getValueFromSearchParam,
  removeValueFromSearchParam,
  setURLSearchParam,
} from '@utils/history';
import { deepCopy } from '@utils/common';
import StateSwitch from './stateSwitch';
import UploadExcelModal from './uploadExcelModal';
import actions from '@flux/action';
import EditButton from './editButton';
import alert from '@components/alert';
import { projectRole } from '@model';
import { useHistory } from 'react-router-dom';
import searchParamKeys from '@model/searchParamKeys';

export const CURRENT = 0;
export const FUTURE = 1;

function filterSubsidiariesByCountry(subsidiaries = [], countryNames = []) {
  return subsidiaries.filter(
    (subs) =>
      countryNames.some((name) => subs.completeLoc?.includes(name)) ||
      subs.children.filter((s) =>
        countryNames.some((name) => s.completeLoc?.includes(name)),
      ).length > 0,
  );
}

function filterOfficeLocationsByCountry(
  officeLocations = [],
  countryNames = [],
) {
  return officeLocations.filter((i) =>
    countryNames.some(
      (name) => name === i?.countryName || name.includes(i?.countryName),
    ),
  );
}

const Subsidiaries = ({
  others: sub,
  toggleLoading,
  initialExpand = false,
  onExpandChange,
  showLoading = true,
  disableEdit = false,
  mockFutureData = false,
  refetch,
}) => {
  const dispatch = useDispatch();

  const { isClient, projectId, editPermission } = useSelector(
    ({ common, login }) => ({
      isClient: login.userInfo.role === 'client',
      projectId: common.currentId,
      editPermission:
        common.projectCompanyInfo.currentUserPermission ===
        projectRole.Contributor,
    }),
  );
  const { expand: expandFromSearch } = getValueFromSearchParam(
    searchParamKeys.expand,
  );

  const [switchBtn, setSwitchBtn] = useState(false);
  const [expand, setExpand] = useState(
    initialExpand || Boolean(expandFromSearch),
  );
  const [show, setShow] = useState(true);
  const [data, setData] = useState(sub);
  const [isModalShow, setIsModalShow] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [stateOfCurFuSwitch, setStateOfCurFuSwitch] = useState(CURRENT);
  const [hasEverUploaded, setHasEverUploaded] = useState(false);
  const [uploadHistory, hasUploadHistory] = useState(true);
  const history = useHistory();
  const isFutureState = stateOfCurFuSwitch === FUTURE;
  const mapData = isFutureState ? data.futureMap : data.map;

  const fetchData = async () => {
    showLoading && toggleLoading(true);
    const details = await API.getOtherDetails(projectId, 'subsidiary');
    if (mockFutureData) {
      setData({
        ...details,
        hasFutureOfficeLocationData: true,
        hasFuturePresenceData: true,
      });
      setHasEverUploaded(true);
    } else {
      setData(details);
      setHasEverUploaded(details.hasUDInfo);
    }
    showLoading && toggleLoading(false);
  };

  useEffect(() => {
    if (data) {
      const { view, futureState } = getValueFromSearchParam(
        searchParamKeys.view,
        searchParamKeys.futureState,
      );
      const hasFutureData =
        data?.hasFuturePresenceData || data?.hasFutureOfficeLocationData;
      if ((view === 'map' || !view) && futureState && hasFutureData) {
        onStateSwitchChange(FUTURE);
        removeValueFromSearchParam(searchParamKeys.tab);
      } else if (view === 'grid') {
        handleSwitch();
        removeValueFromSearchParam(searchParamKeys.futureState);
      }
    }
  }, [data]);

  const onReset = async () => {
    await API.resetLESubsidiaries(projectId);
    hasUploadHistory(false);
    fetchData();
    hasUploadHistory(true);
    onStateSwitchChange(CURRENT);
    if (typeof refetch === 'function') {
      refetch();
    }
  };

  const editButton =
    isClient || !editPermission || disableEdit ? null : (
      <EditButton
        inExpand={expand}
        hasEverUploaded={hasEverUploaded}
        onReset={onReset}
      />
    );

  const handleSwitch = () => {
    setSwitchBtn((state) => {
      const nextSearchParams = {
        [searchParamKeys.view]: state ? 'map' : 'grid',
      };
      if (stateOfCurFuSwitch === FUTURE && state) {
        nextSearchParams[searchParamKeys.futureState] = 1;
      }
      setURLSearchParam(history, nextSearchParams);
      removeValueFromSearchParam(
        history,
        state ? [searchParamKeys.tab] : [searchParamKeys.futureState],
      );
      return !state;
    });
  };

  useEffect(() => {
    if (!sub) {
      fetchData();
    }
    setHasEverUploaded(Boolean(data?.hasUDInfo));
  }, []);
  const handleMapClickCb = (countryName, companyIndex) => {
    setIsModalShow(true);
    let filteredData;
    const countryNames = countryName.includes('/')
      ? countryName.split('/').filter((i) => i)
      : [countryName];

    const gridData =
      stateOfCurFuSwitch === CURRENT ? data.grid : data.futureGrid;

    if ([0, 1].includes(companyIndex)) {
      filteredData = deepCopy(gridData[companyIndex]);
      filteredData.subsidiaries = filterSubsidiariesByCountry(
        filteredData.subsidiaries,
        countryNames,
      );
      filteredData.officeLocations = filterOfficeLocationsByCountry(
        filteredData.officeLocations,
        countryNames,
      );
      filteredData = new Array(filteredData);
    } else {
      filteredData = deepCopy(gridData).map((grid) => {
        grid.subsidiaries = filterSubsidiariesByCountry(
          grid.subsidiaries,
          countryNames,
        );
        grid.officeLocations = filterOfficeLocationsByCountry(
          grid.officeLocations,
          countryNames,
        );
        return grid;
      });
    }
    setModalData(filteredData);
  };
  const handleExpand = () => {
    setExpand((state) => {
      if (!state) {
        setURLSearchParam(history, {
          [searchParamKeys.expand]: true,
        });
      } else {
        removeValueFromSearchParam(history, [searchParamKeys.expand]);
      }
      return !state;
    });
    if (typeof onExpandChange === 'function') {
      onExpandChange(!expand);
    }
    if (switchBtn) {
      setShow(false);
      setTimeout(() => {
        setShow(true);
      }, 300);
    }
  };

  const showModalIfIsInternal = () => {
    if (isClient || !editPermission) {
      alert.warning('The future data has not been uploaded.');
      return;
    }
    dispatch(actions.toggleLeUploadModal(true));
  };

  const onStateSwitchChange = (v) => {
    // console.log('v: ', v);
    // console.log('data: ', data);
    if (v === FUTURE && !data) {
      return;
    }
    if (
      v === FUTURE &&
      !data?.hasFuturePresenceData &&
      !data?.hasFutureOfficeLocationData
    ) {
      showModalIfIsInternal();
      return;
    }
    if (v === FUTURE && !switchBtn) {
      setURLSearchParam(history, { [searchParamKeys.futureState]: v });
    } else {
      removeValueFromSearchParam(history, [searchParamKeys.futureState]);
    }
    setStateOfCurFuSwitch(v);
  };

  const stateSwitch = (
    <StateSwitch value={stateOfCurFuSwitch} onSwitch={onStateSwitchChange} />
  );

  const onSaveUpload = () => {
    fetchData();
    if (typeof refetch === 'function') {
      refetch();
    }
  };

  return (
    <div className={`analysis-right-wrapper ${expand && 'full-screen'}`}>
      <UploadExcelModal
        onComplete={onSaveUpload}
        type="LE"
        keepHistory={uploadHistory}
      />
      <div className="title title-subsidiary expand-box special-expand-box">
        <div>Operational Footprint</div>
        <div className="special-expand-icon">
          <div className="title-subsidiary-right">
            Map &nbsp;
            <SwitchBtn checked={switchBtn} onClick={handleSwitch} />
            &nbsp;Grid
          </div>
          {data && (
            <ExpandButton
              onClick={handleExpand}
              scrollPageFooter
              initialExpand={initialExpand || Boolean(expandFromSearch)}
            />
          )}
        </div>
      </div>
      <Modal
        // getContainer={}
        height={600}
        footer={null}
        className="subsidiaries-modal"
        visible={isModalShow}
        onCancel={() => setIsModalShow(false)}
        destroyOnClose={true}
      >
        <Grid data={modalData} isShownInModal={true} expand={true} />
      </Modal>
      {show && data ? (
        switchBtn ? (
          <Grid
            data={isFutureState ? data.futureGrid : data.grid}
            reportDate={[
              data?.buyerFactivaReportingDate,
              data?.targetFactivaReportingDate,
            ]}
            expand={expand}
            stateSwitch={stateSwitch}
            hasEverUploaded={hasEverUploaded}
            editButton={editButton}
            stateOfCurFuSwitch={stateOfCurFuSwitch}
            // countries={{
            //   buyerCountries: {
            //     countryNames: mapData?.buyerCountryNames,
            //     officeCountryNames: mapData?.buyerOfficeCountryNames,
            //   },
            //   sellerCountries: {
            //     countryNames: mapData?.targetCountryNames,
            //     officeCountryNames: mapData?.targetOfficeCountryNames,
            //   },
            // }}
          />
        ) : (
          <SubsidiariesMap
            data={mapData}
            expand={expand}
            handleMapClickCb={handleMapClickCb}
            stateSwitch={stateSwitch}
            hasEverUploaded={hasEverUploaded}
            editButton={editButton}
            headcount={data?.headcount}
          />
        )
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default connect(null, (dispatch) => ({
  toggleLoading(bool) {
    dispatch(actions.changeLoading(bool));
  },
}))(memo(Subsidiaries));
